export function formatRate(amount, locale = 'en-AE') {
  const num = Number(amount);
  if (isNaN(num)) {
    return '';
  }
  const digits = Math.floor(num).toString().length;
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: digits >= 4 ? 0 : 2,
    maximumFractionDigits: digits >= 4 ? 0 : 2
  }).format(num);
}
